import { render, staticRenderFns } from "./rfm-score.vue?vue&type=template&id=f9bd588a&"
import script from "./rfm-score.vue?vue&type=script&lang=js&"
export * from "./rfm-score.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports